import React from 'react';

// Shared status tag used by Acceptance Criteria, Sampling Plans, Risk
// Assessment (and any future e-sign-approval page), drawn as an AiventraLMS
// <Tag> (lms-tms-app/frontend/src/components/ui/Tag.jsx) so the color map
// lives in one place.
export const STATUS_TAG_CLASSES = {
  Draft: 'bg-gray-100 dark:bg-white/10 text-gray-700 dark:text-text-secondary border-gray-200 dark:border-border-secondary',
  'Pending Approval': 'bg-yellow-50 dark:bg-yellow-500/10 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-500/30',
  'Pending QA Approval': 'bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-500/30',
  Submitted: 'bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-500/30',
  Approved: 'bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-300 border-green-200 dark:border-green-500/30',
  Released: 'bg-green-50 dark:bg-green-500/10 text-green-700 dark:text-green-300 border-green-200 dark:border-green-500/30',
  Rejected: 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-300 border-red-200 dark:border-red-500/30',
};

// Kept for callers that color other elements to match a status.
export const STATUS_COLORS = {
  Draft:                 { bg: 'var(--surface-light)', color: 'var(--text-secondary)', border: 'var(--border-color)' },
  'Pending Approval':    { bg: 'var(--warning-bg)', color: 'var(--warning-text)', border: 'var(--warning-border)' },
  'Pending QA Approval': { bg: 'var(--info-bg)', color: 'var(--info-text)', border: 'var(--info-border)' },
  Approved:              { bg: 'var(--success-bg)', color: 'var(--success-text)', border: 'var(--success-border)' },
  Rejected:              { bg: 'var(--danger-bg)', color: 'var(--danger-text)', border: 'var(--danger-border)' },
};

export const StatusBadge = ({ status }) => (
  <span className={`tag ${STATUS_TAG_CLASSES[status] || STATUS_TAG_CLASSES.Draft}`}>
    {status || 'Draft'}
  </span>
);

export default StatusBadge;
